<script>
  import {createEventDispatcher} from 'svelte';
  import share from './index.js';

  const dispatch = createEventDispatcher()
  export let data;
  export let isOpen = false;
  export let isShareable = share.check();

  let image;
  let blob;
  let burl;
  let modalBody;
  let downloadlink;


  $:{
    if(isOpen === true){
      modalOpen();
    }

  }


  function modalOpen(){
    setTimeout(() =>{
      data.canvas.toBlob((blb)=>{
        blob = blb;
        burl = image.src = URL.createObjectURL(blob);
        downloadlink.href =burl

        image.style.transform = `scale(${dialogData.scale},${dialogData.scale})`;
        image.onload = () =>{
            modalBody.style.height = `${image.clientHeight + 10}px`;
        }




      })

    },0);
    dispatch('open', {});


  }
  function modalClose(){
    isOpen = false;
    URL.revokeObjectURL(burl);
    dispatch('close', {})

  };

  function shareImage(){
    share.execute('#座標変換写真', location.href,blob);

  }
</script>
{#if isOpen}
<div id='backwindow' on:click|self={modalClose}>
  <div  class='dialog'>
      <div class='modal_headline' on:click={modalClose}><span>X</span></div>
      <figure class='modal_body' bind:this={modalBody}>
        <img bind:this={image}/>
      </figure>
      <div class='modal_footer'>
        <a bind:this={downloadlink} download="coordinate_transformation.png" class='button'>保存する</a>{#if isShareable === true}<button on:click={shareImage}>共有する</button>{/if}<button on:click={modalClose} class='danger'>閉じる</button>
      </div>
  </div>
</div>
{/if}
<style>
#backwindow{
  position: fixed;
  z-index: 1000;
  width: 100%;
  height: 100%;
  background: rgba(33, 32, 7, 0.66);
  top:0;
  left:0;
  overflow: scroll;
}
 .dialog{
    margin-left: 5%;
    margin-top: 1.5em;
    width: 90%;
    border-radius: 5px;
    background-color: white;
    padding-bottom: 0.5em;
    margin-bottom: 1.5em;
    flex-direction: column;
    justify-content: center;
    align-items: center;


  }

  .modal_headline{
    width: 100%;
    text-align: right;
    background-color: #E4DE31;
    color:#fffdcc;
    padding-bottom:0.4em;
    padding-top:0.4em;
    border-top-right-radius: 5px;
    border-top-left-radius:5px;

  }
  .modal_headline span{
    margin-right:0.75em;
  }
  .modal_footer{
    text-align: center;
  }
  .modal_footer .button, .modal_footer button{
    margin-right:0.4em;

  }
.modal_body{
  text-align: center;
}
</style>
